import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledQuestionIcon = styled(FontAwesomeIcon)`
  && {
    height: 2rem;
    width: 2rem;
    color: ${({ theme }) => theme.colors.grey[600]};
  }
`;

export const StyledMessage = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 1.6rem;
`;

export const StyledChangesInputWrapper = styled.div`
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
`;
